import { env } from "./env.ts";

export const signOut = async (): Promise<void> => {
  const res = await fetch(`${env.VITE_WEB_URL}/api/auth/sign-out`, {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: "{}",
  });
  if (!res.ok) {
    throw new Error("Couldn't sign out. Try again.");
  }
  window.location.reload();
};
